import { useState } from 'react'

export type ChartHover = { key: string; x: number; y: number; title: string; value: string }

/**
 * Tracks the hovered part of a chart and where the pointer is, relative to the closest element
 * marked with `data-chart` (which must be positioned).
 */
export function useChartHover(): {
  hover: ChartHover | null
  track(event: React.MouseEvent<Element>, key: string, title: string, value: string): void
  clear(): void
} {
  const [hover, setHover] = useState<ChartHover | null>(null)
  return {
    hover,
    track(event, key, title, value) {
      const box = event.currentTarget.closest('[data-chart]')?.getBoundingClientRect()
      if (!box) return
      setHover({ key, x: event.clientX - box.left, y: event.clientY - box.top, title, value })
    },
    clear: () => setHover(null)
  }
}
